import { useMutation, useQueryClient } from "react-query";
import { makeAuthedRequest } from "utils/makeAuthedRequest";

const useReviewAddress = () => {
  const queryClient = useQueryClient();

  const confirmAddress = async ({ entityId, address }) => {
    const response = await makeAuthedRequest(
      `v1/settings/sub-entity/address/${entityId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ address }),
      }
    );

    if (!response.ok) {
      let errorBody;
      try {
        errorBody = await response.json();
      } catch (e) {
        console.error("Failed to parse error response JSON:", e);
        throw new Error(
          "Failed to confirm address, and the error response was not valid JSON"
        );
      }
      throw new Error(errorBody.message || "Failed to confirm address");
    }

    let responseBody;
    try {
      const textResponse = await response.text();
      responseBody = textResponse ? JSON.parse(textResponse) : {};
    } catch (e) {
      console.error("Failed to parse JSON response:", e);
      throw new Error("Failed to parse JSON response");
    }

    return responseBody;
  };

  return useMutation(confirmAddress, {
    onSuccess: () => {
      // Invalidate and refetch the subEntityData query
      queryClient.invalidateQueries(["subEntityInfo"]);
    },
  });
};

export default useReviewAddress;
